import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Avatar, Button, Input, message, Radio} from "antd";
import {deepTranslate, getFullAddress, renderIf} from "../../../Shared";
import _ from "lodash";
import Translate from "../../../../modules/local/Translate";
import {compose, mapProps, pure} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {appClassNames} from "../../custom/appClassNames";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import {useToggle} from "react-use";
import {Formik, FormikConsumer} from "formik";
import {Pure} from "../../../../components/Pure";
import FormActionBar from "../../../../components/form/FormActionBar";
import FieldsFactory from "../../../../components/form/FieldsFactory";
import {NullAsDefault, shallowDiff} from 'views/Shared'
import LookupField from "../../../../components/LookupField";
import {RiMapPinFill} from "react-icons/ri";
import {BiSolidChurch} from "react-icons/bi";
import {LocationStaticMap, ToggleMap} from "../../../../components/form/fields/LocationMap";
import {HeaderBlock} from "../../../MainPage/components/HeaderBlock";
import {MdChurch, MdPassword} from "react-icons/md";
import {IoCopy} from "react-icons/io5";
import copyToClipboard from "copy-to-clipboard";
import {createConfirmApproveDialog} from "../../factory/createConfirmDialog";
import {useEventLocationApi} from "../functions/useEventLocationApi";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {DelayRender} from "../../../Shared/components/DelayRender";
import {SiOpenstreetmap} from "react-icons/si";
import {LeafletMap} from "../../../../components/form/fields/LeafletMap";
import {ItemInformation} from 'components/common/ItemInformation'
import {BsInfoCircleFill} from "react-icons/bs";
import {showInfoDialog} from "../../factory/createInfoDialog";
import {useCheckinApi} from "../../Church/functions/useCheckinApi";
import {useRequiredLogin} from "../../../Server/useRequiredLogin";
import {getType} from "../../../../apis/model/base";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";

const formSchema = {
    church: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'church',
                name: 'church_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose church')}
                                    createIfNotExists={false}
                                    defaultValue={form?.values?.church_name}
                                    selectedOption={form?.values?.church}
                                    apiPath={`/lookup/church/get-by-types`}
                                    placeholder={t('click to select')}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => (
                                        <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                            <Avatar
                                                size={50}
                                                src={o.photo}
                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col gap-1 flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {o.label}
                                                </span>
                                                <div className="flex items-center gap-x-1">
                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                    <span
                                                        className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                        {getFullAddress(o)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            church: e.target,
                                            church_name: e.target.value,
                                            church_id: e.target.id,
                                            name: e.target.name,
                                            address: e.target.address,
                                            longitude: e.target?.coordinate?.longitude,
                                            latitude: e.target?.coordinate?.latitude,
                                            map_preview: e.target?.coordinate?.static_map_url,
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    name: {
        title: 'locations name',
        children: [
            {
                name: 'name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('location name'),
                    })),
                    pure
                )(Input),
            },
        ],
    },
    church_parent: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form}) => {
                    const {church, parish} = form?.values ?? {}

                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={church ? church?.parish_name : parish?.name}
                                            selectedOption={church ? church?.parish : parish}
                                            placeholder={t('click to select')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={50}
                                                                src={o.avatar}
                                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                            />
                                                        )}
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                                <span className="font-bold text-sm text-color-000">
                                                                    {fullname}
                                                                </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                                                    {`( ${diocese_fullname} )`}
                                                                </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form}) => {
                    const {church, diocese} = form?.values ?? {}
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={church ? church?.diocese_name : diocese?.name}
                                            selectedOption={church ? church?.diocese : diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            placeholder={t('click to select')}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },

    description: {
        title: 'description',
        children: [
            {
                name: 'description',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        value,
                        name: 'description',
                        placeholder: translate('short description'),
                        type: 'text',
                        rows: 4,
                    }))
                )(Input.TextArea),
            },
        ],
    },
    address: {
        title: 'address',
        children: [
            {
                name: 'address',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        value,
                        name: 'address',
                        placeholder: translate('ex: address'),
                        type: 'text',
                    }))
                )(Input),
            },
        ],
    },

    idname: {
        title: 'ID code',
        children: [
            {
                name: 'idname',
                component: compose(
                    mapProps(({onChange, value, form}) => ({
                        event_location_id: form?.values?.id,
                        idname: form?.values?.idname,
                        formValues: form?.values,
                    })),
                )((props) => {
                    return (
                        <div className="flex flex-col gap-2">
                            <EventLocationIdname {...props}/>
                        </div>
                    )
                }),
            },
        ],
    },
    status: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'active',
                name: 'active',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="custom-radio-button"
                                options={baseFieldTypes.active.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
}

const EventLocationIdname = ({...props}) => {
    const t = useTranslate();
    const {resetSecretKey} = useEventLocationApi({});

    return (
        <div className="mt-2 flex items-center justify-between gap-x-6 md:gap-x-10">
            <div className="w-full md:w-1/2 flex flex-col">
                <HeaderBlock
                    size={26}
                    icon={<MdPassword size={14} className="text-color-300"/>}
                    renderTitle={() => (
                        <span className="font-semibold text-color-300 tracking-wider leading-tight">
                            {t('ID code')}
                        </span>
                    )}
                    className="background-200"
                />
                <div
                    style={{padding: '8px 12px', boxShadow: '0 4px 4px -3px rgba(0, 0, 0, 0.1)'}}
                    className="border-b rounded-lg">
                    <span className="ml-6 font-bold text-lg text-color-000 tracking-wide">
                        {props?.idname || `*** *** `}
                        <IoCopy
                            size={14}
                            onClick={() => {
                                copyToClipboard(props?.idname)
                                message.success(t('copied'))
                            }}
                            className="ml-3 text-blue-500 hover:text-blue-700 cursor-pointer"
                        />
                    </span>
                </div>
            </div>
            <Button
                onClick={() => {
                    createConfirmApproveDialog({
                        translate: t,
                        title: 'create id code',
                        message: 'do you want to create id code',
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        okButtonProps: {
                            type: 'primary',
                            className: 'button-rounded-md no-border',
                        },
                        cancelButtonProps: {
                            type: 'text',
                            className: 'button-rounded-md no-border',
                        },
                        onOk: () => {
                            resetSecretKey({}, {id: props?.event_location_id})
                        },
                    })
                }}
                color="primary" variant="filled"
                className="button-rounded-md font-medium">
                {t('create id code')}
            </Button>
        </div>

    )
}

export const DetailViewForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const handleRequiredLogin = useRequiredLogin()
    const history = useHistory()

    const {name, address, description, latitude, longitude} = item ?? {}

    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`

    const {onCheckIn, checkedInModal} = useCheckinApi({
        item: !!item?.owner ? item?.owner : item,
        notifyListeners: {
            onSuccessCheckedIn: (__, data) => {

            },
            onErrorCheckedIn: (error, errorObj) => {

            },
        }
    })

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col">
                <HeaderBlock
                    size={26}
                    icon={<BsInfoCircleFill size={14} className="text-blue-500"/>}
                    renderTitle={() => (
                        <span className="font-semibold text-sm text-blue-600 tracking-wider">
                            {t('location information')}
                        </span>
                    )}
                    className="bg-blue-100"
                />
                <div className="p-3 flex flex-col gap-1 border-b border-color-50 rounded-b-lg shadow-xs">
                    <div className="font-bold text-lg text-primary-800 tracking-wide">
                        {name}
                    </div>
                    <ItemInformation showIcon={true} label="address" value={address}
                                     className="space-x-2 text-xs italic"/>
                    {renderIf(
                        description,
                        <div className="text-sm text-color-300 tracking-wider">
                            {`\u2003 ${description}`}
                        </div>
                    )}
                </div>
            </div>
            {renderIf(
                _.some([latitude, longitude]),
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        renderTitle={() => (
                            <span className="font-medium text-sm text-color-400 tracking-wider">
                                {t('maps direction')}
                            </span>
                        )}
                    />
                    <DelayRender lazy={true}>
                        <a
                            href={mapUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="custom-toggle-map no-underline rounded-lg cursor-pointer relative">
                            <div
                                className="mask-map h-full flex-col flex-center gap-2 rounded-lg absolute top-0 z-10">
                                <SiOpenstreetmap size={40} className="text-white opacity-85"/>
                                <div className="flex flex-col items-center">
                                    <div style={{color: '#fff'}} className="font-semibold leading-snug">
                                        {t('view map')}
                                    </div>
                                    <div className="text-2xs text-white italic opacity-50 leading-tight">
                                        {t('click to open the map')}
                                    </div>
                                </div>
                            </div>
                            <LeafletMap
                                style={{
                                    height: isLg ? 180 : 120,
                                }}
                                zoom={12}
                                zoomControl={false}
                                latitude={latitude}
                                longitude={longitude}
                            />
                        </a>
                    </DelayRender>
                </div>
            )}
            <div className="flex flex-col gap-3">
                <Button
                    onClick={() => {
                        if (!!!latitude || !!!longitude) {
                            showInfoDialog({
                                title: t("Location access required"),
                                message: t("Please enable location access to proceed with check-in."),
                                translate: t
                            })
                        } else {
                            handleRequiredLogin(
                                () => onCheckIn({latitude, longitude}, {
                                    owner_type: getType(item),
                                    owner_id: item?.id
                                })
                            )

                        }
                    }}
                    color="primary" variant="solid"
                    style={{
                        width: 'fit-content',
                        padding: '1.25rem 1.5rem',
                        borderRadius: '0.5rem'
                    }}
                    className="mx-auto my-1 font-semibold text-base shadow-lg">
                    {t('tap to checkin')}
                </Button>
                <div className="flex flex-col shadow-md rounded-lg italic">
                    <div
                        className="px-2 py-1 background-200 rounded-t-lg font-semibold text-color-200 tracking-wide">
                        {`${t('note')}: `}
                    </div>
                    <div
                        className="px-3 py-2 border-b rounded-b-lg text-color-200 tracking-wider">
                        {`${t('note pilgrimage checkin description')}.`}
                    </div>
                </div>
            </div>
            {checkedInModal}
        </div>
    )
}

export const CreateEventLocationForm = ({
                                            onCancel = NullAsDefault,
                                            onSubmit = NullAsDefault,
                                        }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()

    const validate = (values) => {
        let errors = {}
        _.forEach(['name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    const initialValues = {
        name: undefined,
        description: undefined,
        address: undefined,
        church_id: undefined,
        status: 1,
        active: 1,
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onPreSubmit={({church, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                return _.omitBy(
                    {
                        ...changes,
                    },
                    _.isUndefined
                )
            }}
            onSubmit={({church, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.church,
                            formSchema.church_parent,
                            formSchema.name,
                            formSchema.address,
                            formSchema.description,
                            formSchema.status,
                        ]}
                    />
                </Pure>
                <FormikConsumer>
                    {({values, setFieldValue, ...restForm}) => {
                        return (
                            <div className="custom-toggle-map no-underline rounded-lg cursor-pointer relative">
                                <ToggleMap
                                    latitude={values?.latitude}
                                    longitude={values?.longitude}
                                    preview_url={values?.map_preview}
                                    onClick={toggle}
                                    onRemove={() => {
                                        restForm.setValues({
                                            ...values,
                                            latitude: null, longitude: null, map_preview: null
                                        });
                                    }}
                                />
                                <LocationStaticMap
                                    locationName={values?.name}
                                    toggle={toggle}
                                    isToggle={isToggle}
                                    latLng={[values?.latitude, values?.longitude]}
                                    onSelect={(_values) => {
                                        restForm.setValues({
                                            ...values,
                                            ..._values
                                        });
                                    }}
                                />
                            </div>
                        )
                    }}
                </FormikConsumer>
                <FormActionBar submitText="create"/>
            </div>
        </Formik>
    )
}

export const EditEventLocationForm = ({
                                          item,
                                          initialValues,
                                          onCancel = NullAsDefault,
                                          onSubmit = NullAsDefault,
                                      }) => {
    const t = useTranslate()

    const [isToggle, toggle] = useToggle()
    const [current, setCurrent] = useState('overview')

    const _initialValues = {
        ...initialValues,
        church_id: _.get(initialValues, 'church.id', ''),
        church_name: _.get(initialValues, 'church.name', ''),
        name: _.get(initialValues, 'name', ''),
        idname: _.get(initialValues, 'idname', ''),
        parish_id: _.get(initialValues, 'parish.id', ''),
        parish_name: _.get(initialValues, 'parish_name', ''),
        parish: _.get(initialValues, 'parish'),
        diocese_id: _.get(initialValues, 'diocese.id', ''),
        diocese_name: _.get(initialValues, 'diocese_name', ''),
        diocese: _.get(initialValues, 'diocese'),
    }

    const validate = (values) => {
        let errors = {}
        _.forEach(['name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onPreSubmit={({church, ...values}) => {
                return _.omitBy(
                    {
                        ...values,

                    },
                    _.isUndefined
                )
            }}
            onSubmit={({church, diocese_id, parish_id, ...values}) => {
                const changes = shallowDiff(values, _initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        diocese_id,
                        parish_id,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <ActionModalWrapper
                    tab={current}
                    action={<FormActionBar submitText="save"/>}
                    onTabChange={(key) => {
                        setCurrent(key)
                    }}
                    tabs={[
                        {
                            key: 'overview',
                            label: 'overview',
                            component: ({child}) => child,
                        },
                        {
                            key: 'secure',
                            label: 'Safe Secure',
                            component: () => (
                                <FieldsFactory
                                    formSchema={[
                                        formSchema.idname,
                                        formSchema.status,
                                    ]}
                                />
                            ),
                        }
                    ]}>
                    <FieldsFactory
                        formSchema={[
                            formSchema.church,
                            formSchema.church_parent,
                            formSchema.name,
                            formSchema.description,
                            formSchema.address,
                        ]}
                    />
                    <FormikConsumer>
                        {({values, setFieldValue, ...restForm}) => (
                            <div className="custom-toggle-map no-underline rounded-lg cursor-pointer relative">
                                <ToggleMap
                                    latitude={values?.latitude}
                                    longitude={values?.longitude}
                                    preview_url={values.map_preview}
                                    onClick={toggle}
                                    onRemove={() => {
                                        restForm.setValues({
                                            ...values,
                                            latitude: null, longitude: null, map_preview: null
                                        });
                                    }}
                                />
                                <LocationStaticMap
                                    locationName={values.name}
                                    toggle={toggle}
                                    isToggle={isToggle}
                                    latLng={[values.latitude, values.longitude]}
                                    onSelect={(_values) => {
                                        restForm.setValues({
                                            ...values,
                                            ..._values
                                        });
                                    }}
                                />

                            </div>
                        )}
                    </FormikConsumer>
                </ActionModalWrapper>
            </div>
        </Formik>
    )
}